const styles = (theme) => ({
  cardBody: {
    background: theme.colorPalette.white_30,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8)
  },
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    width: '100%',
    padding: theme.spacing(6, 8),
    margin: 0,
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners,
    rowGap: theme.spacing(4)
  },
  header: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  headerStatus: {
    paddingTop: 4,
    fontStyle: 'italic',
    textTransform: 'none',
    maxWidth: 570
  },
  addCarDetailsForm: {
    display: 'flex',
    flexDirection: 'column'
  },
  iconButtonRoot: {
    color: theme.colors.button__background_secondary,
    padding: 0
  },
  iconButtonLabel: {
    height: 32,
    width: 32
  },
  icon: {
    height: 32,
    transition: 'transform 200ms'
  },
  collapse: {
    transform: 'rotate(180deg)'
  },
  addCarDetailsLabel: {
    fontSize: 16,
    cursor: 'pointer'
  },
  addCarDetailsButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    color: theme.colorPalette.orange_10
  },
  luxuryCheckbox: {
    marginTop: 10,
    paddingLeft: theme.spacing(1)
  },
  noMargin: {
    margin: 0
  }
});

export default styles;
